import { UserRole } from '@interfaces/users.interface';

export const mapUserRole = (role: UserRole): string => {
  switch (role) {
    case 'admin':
      return 'Admin';
    case 'customer':
      return 'Cliente';
  }
};

export const getMarketCategoryColor = (category: string) => {
  switch (category) {
    case 'Cosmetico':
      return '#C9375A';
    case 'Farmaceutico':
      return '#4A7BB4';
    case 'Ricerca':
      return '#9EC390';
    case 'Alimentare':
      return '#E18C4F';
    case 'Nutraceutico':
      return '#B390C3';
    default:
      return '#000000';
  }
};
